import { Fragment } from 'react';
import { Route, Switch } from 'react-router';

import NoIndex from 'components/atoms/NoIndex';
import Login from 'screens/Login';
import Authentication from 'screens/Authentication';

const PublicRoutes = () => (
  <Fragment>
    {/* "Public" only in the routing sense — these are the portal's sign-in and
        OTP screens, and have no business being indexed. */}
    <NoIndex />
    <Switch>
      <Route path="/clients/sign_in" component={Login} exact />
      <Route path="/clients/two_factor_authentication" component={Authentication} exact />
    </Switch>
  </Fragment>
);

export default PublicRoutes;
